import { FC } from "react";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { PriceTypes } from "../../../typings/PriceTypes";
import { MeasurementSystem } from "src/js/stores/user/store";
import { Dropdown, DropdownItem } from "react-migration/components/Dropdown";

export interface PriceTypeProps {
  priceType: PriceTypes;
  setPriceType: (priceType: PriceTypes) => void;
  unitPreference: MeasurementSystem;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventTracking?: (values: { filterName: string; filterState: any }) => void;
}

export const PriceType: FC<PriceTypeProps> = ({ priceType, setPriceType, unitPreference, eventTracking }) => {
  const { t } = useTranslation();

  enum DropdownPriceTypes {
    PER_AREA = "PER_AREA",
    PER_UNIT = "PER_UNIT",
  }

  const dropdownOptions: DropdownItem<DropdownPriceTypes>[] = [
    {
      label: t("comparables.map.sidebar.filters.type.map.per_area", {
        currency: t("units.currency.default_currency"),
        areaType: t(
          unitPreference === MeasurementSystem.METRIC
            ? "comparables.map.sidebar.filters.mode.price.sqm.alt"
            : "comparables.map.sidebar.filters.mode.price.sqft.alt"
        ),
      }),
      value: DropdownPriceTypes.PER_AREA,
    },
    {
      label: t("comparables.map.sidebar.filters.type.map.per_unit"),
      value: DropdownPriceTypes.PER_UNIT,
    },
  ];

  return (
    <div className="flex flex-col gap-2">
      <div data-testid="price-type" className="flex flex-col gap-1">
        <div className="text-sm">{t("comparables.map.sidebar.filters.mode.price.source")}</div>
        <Dropdown<DropdownPriceTypes>
          value={priceType === 0 ? DropdownPriceTypes.PER_UNIT : DropdownPriceTypes.PER_AREA}
          placeholder=""
          dataTestId="price-type-dropdown"
          name="priceType"
          classNameContainer="w-full whitespace-nowrap"
          optionsContainerClassName="whitespace-normal"
          handleValueChange={(opt) => {
            eventTracking?.({ filterName: "priceType", filterState: opt });
            setPriceType(opt.value === DropdownPriceTypes.PER_AREA ? PriceTypes.PER_AREA : PriceTypes.PER_UNIT);
          }}
          options={dropdownOptions}
        />
      </div>
    </div>
  );
};
